define(["require", "exports", "jquery", "knockout", "log", "../../utils/kendoUtils", "../../utils/tools", "../../models/UserContext", "../../models/CustomerExternalUserModel", "../../models/CustomerPbxAccountModel", "../settings/companySettings", "../../utils/urls"], function (require, exports, $, ko, log, KendoUtils, tools, UserContext, CustomerExternalUserModel, CustomerPbxAccountModel, CompanySettings, urls_1) {
    "use strict";
    var CustomerPbxAccounts = /** @class */ (function () {
        function CustomerPbxAccounts(customerId, initGridCallback) {
            this.userCanView = ko.observable(UserContext.hasAccess("Admin,CustomerPbx.View,CustomerPbx.Edit,CustomerPbx.Delete"));
            this.userCanEdit = ko.observable(UserContext.hasAccess("Admin,CustomerPbx.Edit,CustomerPbx.Delete"));
            this.userCanDelete = ko.observable(UserContext.hasAccess("Admin,CustomerPbx.Delete"));
            this.customerId = ko.observable(0);
            this.sendToEmail = ko.observable("");
            this.editModel = ko.observable(new CustomerExternalUserModel());
            this.pbxAccountEditModel = ko.observable(new CustomerPbxAccountModel());
            this.isLookupDataLoaded = false;
            this.isInitGridRequested = false;
            this.customerAcrobitsSettingsId = ko.observable(0);
            this.pbxExtensionDependenciesModel = ko.observableArray([]);
            var self = this;
            self.customerId(customerId);
            if (self.userCanView()) {
                // Get lookup data:
                tools.ajaxGet({
                    url: "/CustomerPbx/GetPbxLookupData",
                    data: { customerId: self.customerId() },
                    success: function (data) {
                        if (data.Success) {
                            self.lookupLists = data.Data.lookupLists;
                            self.customerAcrobitsSettingsId(self.lookupLists.CustomerAcrobitsAccountSettingId);
                            self.pbxExtensionsGridStructure = self.lookupLists.GridStructures.CustomerPbxExtensionsStructure;
                            self.initExportDataSource();
                            self.isLookupDataLoaded = true;
                            if (self.isInitGridRequested) {
                                self.initGrid();
                            }
                            if (initGridCallback) {
                                initGridCallback(self);
                            }
                        }
                    }
                });
            }
        }
        CustomerPbxAccounts.prototype.initGrid = function () {
            var self = this;
            if (self.userCanView()) {
                if (!this.isLookupDataLoaded) {
                    this.isInitGridRequested = true;
                }
                else {
                    this.initExtensionsTable();
                }
            }
        };
        CustomerPbxAccounts.prototype.initExportDataSource = function () {
            var self = this;
            self.customerPbxExtensionsDataSourceOptions = {
                transport: {
                    read: {
                        url: "/CustomerPbx/GetExtensions",
                        type: "POST",
                        data: function () {
                            var data = {};
                            data.customerId = self.customerId();
                            return data;
                        },
                        dataType: "json"
                    }
                },
                schema: {
                    model: self.pbxExtensionsGridStructure.model,
                    data: function (response) { return response.Data; },
                    total: "Total",
                    aggregates: "Aggregates",
                    errors: "Errors"
                },
                serverPaging: true,
                serverFiltering: true,
                serverSorting: true,
                serverAggregates: false
            };
            self.customerPbxExtensionsDataSource = new kendo.data.DataSource(self.customerPbxExtensionsDataSourceOptions);
        };
        CustomerPbxAccounts.prototype.initExtensionsTable = function () {
            var self = this;
            var gridId = "divPbxExtensionsTable";
            var columns = self.pbxExtensionsGridStructure.columns;
            columns.push({
                field: "",
                title: "",
                width: "100px",
                sortable: false,
                template: function (dataItem) {
                    var html = "";
                    if (self.userCanEdit()) {
                        html += '<a class="btn btn-sm btn-info btn-edit" href="#"><i class="fa fa-edit"></i></a>&nbsp;';
                        html += '<a class="btn btn-sm btn-info btn-send-qr" href="#" title="Send QR Code to client"><i class="fa fa-qrcode"></i></a>&nbsp;';
                        html += '<a class="btn btn-sm btn-warning btn-view-pass" href="#" title="View password"><i class="fa fa-eye "></i></a>';
                    }
                    if (self.userCanDelete()) {
                        //html += '&nbsp;<button class="btn btn-sm btn-danger btn-remove" href="#"><i class="fa fa-trash-o "></i></button>';
                    }
                    return html;
                }
            });
            self.customerPbxExtensionsTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/CustomerPbx/GetExtensions",
                            type: "POST",
                            data: function () {
                                var data = {};
                                data.customerId = self.customerId();
                                return data;
                            },
                            dataType: "json"
                        }
                    }
                },
                gridOptions: {
                    columns: columns,
                    resizable: true,
                    scrollable: true,
                    reorderable: true,
                    columnMenu: true,
                    filterable: {
                        mode: "row menu",
                        extra: false
                    },
                    height: 500,
                },
                enableExport: {
                    entityName: "CustomerPbxAccount",
                    title: "Customer PBX Extensions",
                    enablePdf: false
                },
                allowBulkEdits: {
                    enabled: true,
                    customDataAttributes: 'data-name="#=Name#"'
                },
                gridId: gridId,
                showPagerOnTop: false
            };
            self.customerPbxExtensionsTable.initGrid(gridOptions);
            $("#" + gridId + " tbody").on("click", ".btn-send-qr", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.sendCustomerQRCode(data.Id, data.EmailAddress);
                event.preventDefault();
            }).on("click", ".btn-view-pass", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.viewExtensionPassword(data.Id);
                event.preventDefault();
            }).on("click", ".btn-edit", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.editExtension(data.Id);
                event.preventDefault();
            }).on("click", ".btn-lookup", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.showExtensionDependencies(data.Name, data.Domain);
                event.preventDefault();
            });
        };
        CustomerPbxAccounts.prototype.showExtensionDependencies = function (extension, domain) {
            var self = this;
            var dialog = tools.editModal({
                title: "Extension Dependencies",
                html: "",
                buttonTitle: "Close",
                type: "info",
                save: function () {
                    $(dialog).modal("hide");
                },
                modalOptions: {},
                opened: tools.loadAndBindDialog({
                    template: 'pbxextension-info-template',
                    url: urls_1.urls.getPbxExtensionDependencies,
                    urlParam: {
                        extension: extension,
                        domain: domain
                    },
                    model: self.pbxExtensionDependenciesModel,
                    modelName: 'pbxExtensionDependenciesModel',
                    modelType: CustomerPbxAccountModel,
                    root: self
                })
            });
        };
        CustomerPbxAccounts.prototype.editExtension = function (id) {
            var self = this;
            var title = "Edit Extension";
            tools.editModal({
                title: title,
                buttonTitle: "Save",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    //validate form
                    $(event.currentTarget).button("loading");
                    //self.saveExtension(event.currentTarget, modal);
                    var obj = ko.mapping.toJS(self.pbxAccountEditModel);
                    obj["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
                    tools.ajaxPost({
                        url: "/CustomerPbx/SaveExtension",
                        data: obj,
                        success: function (result) {
                            if (result.Success) {
                                $(modal).modal("hide");
                                tools.success("Changes updated successfully.");
                                if (self.customerPbxExtensionsTable) {
                                    self.customerPbxExtensionsTable.refresh();
                                }
                            }
                        }
                    });
                },
                opened: function (modal) {
                    var getModelCall = tools.ajaxGet({
                        url: "/CustomerPbx/GetExtensionById",
                        data: { id: id },
                        success: function (result) {
                            if (result.Success) {
                                self.pbxAccountEditModel(new CustomerPbxAccountModel(result.Data));
                            }
                            else {
                                log.error(result.Error);
                            }
                        }
                    });
                    $.when(getModelCall).done(function (data) {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'customer-pbx-account-edit-template', data: pbxAccountEditModel }\"></div>");
                        ko.applyBindings(self, modal);
                    });
                }
            });
        };
        CustomerPbxAccounts.prototype.sendCustomerQRCode = function (id, emailAddress) {
            var self = this;
            tools.editModal({
                title: "Send QR Code?",
                text: "Are you sure you want to send QR code for client?",
                buttonTitle: "Send",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    if (!self.sendToEmail()) {
                        tools.error("Email address is required");
                        return;
                    }
                    if (!tools.isValidEmail(self.sendToEmail())) {
                        tools.error("Email address is not valid");
                        return;
                    }
                    $(event.currentTarget).button("loading");
                    tools.ajaxPost({
                        url: "/CustomerPbx/SendQRCodeToCustomer",
                        data: { id: id, emailAddress: self.sendToEmail() },
                        success: function (result) {
                            if (result.Success) {
                                $(modal).modal("hide");
                                tools.success("Email sent successfully.");
                            }
                        }
                    });
                },
                opened: function (modal) {
                    self.sendToEmail(emailAddress);
                    $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'send-qr-code-template', data: $root }\"></div>");
                    ko.applyBindings(self, modal);
                }
            });
        };
        CustomerPbxAccounts.prototype.bulkSendCustomerQRCodes = function () {
            var self = this;
            var listOfIds = [];
            $("#divPbxExtensionsTable .check-row:checked").each(function (index, element) {
                listOfIds.push($(element).data());
            });
            if (listOfIds.length > 0 && listOfIds.length <= 1000) {
                self.onBulkSendCustomerQRCodes(listOfIds);
            }
            else if (listOfIds.length > 1000) {
                tools.error("You can edit only 1000 items at a time");
            }
            else {
                tools.error("Please select at least one item to edit");
            }
        };
        CustomerPbxAccounts.prototype.onBulkSendCustomerQRCodes = function (listOfIds) {
            var extName = listOfIds.map(function (item) {
                return item.name;
            });
            var ids = listOfIds.map(function (item) {
                return item.id;
            });
            tools.confirmModal({
                title: "Send QR Codes?",
                html: "Are you sure you want to send QR codes for clients?<br/>" + extName.join(", "),
                buttonTitle: "Send",
                type: "info",
                modalOptions: {}
            }, function (modal) {
                $(modal).modal("hide");
                tools.ajaxPost({
                    url: "/CustomerPbx/SendQRCodesToCustomers",
                    data: { ids: ids },
                    success: function (result) {
                        if (result.Success) {
                            tools.success("Email sent successfully.");
                        }
                    }
                });
            });
        };
        CustomerPbxAccounts.prototype.syncPbxExtensions = function () {
            var self = this;
            tools.confirmModal({
                title: "Sync PBX Extensions?",
                text: "Are you sure you want to sync PBX extensions with all customers PBX servers?",
                buttonTitle: "Sync",
                type: "info",
                modalOptions: {}
            }, function (modal) {
                $(modal).modal("hide");
                tools.success("PBX Extensions Sync started.");
                tools.ajaxGet({
                    url: "/CustomerPbx/SyncCustomerPbx",
                    data: { customerId: self.customerId() },
                    success: function (result) {
                        if (result.Success) {
                            tools.success("PBX Extensions Sync completed.");
                            self.customerPbxExtensionsTable.refresh();
                        }
                    }
                });
            });
        };
        CustomerPbxAccounts.prototype.viewExtensionPassword = function (id) {
            var self = this;
            tools.editModal({
                title: "Password viewer",
                buttonTitle: "Close",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    self.passwordsModel = null;
                    $(modal).modal("hide");
                },
                opened: function (modal) {
                    var getModelCall = tools.ajaxGet({
                        url: "/CustomerPbx/ShowExtensionPasswords",
                        data: { id: id },
                        success: function (result) {
                            if (result.Success) {
                                self.passwordsModel = result.Data;
                            }
                        }
                    });
                    $.when(getModelCall).done(function () {
                        var html = "<h3>Password not found</h3>";
                        if (self.passwordsModel) {
                            html = "";
                            for (var i = 0; i < self.passwordsModel.length; i++) {
                                html += "<h3><span>".concat(self.passwordsModel[i].Label, "</span>: <b>").concat(self.passwordsModel[i].Value, "</b></h3>");
                            }
                        }
                        $(modal).find(".modal-body").html(html);
                    });
                }
            });
        };
        CustomerPbxAccounts.prototype.editGlobalSettings = function () {
            var self = this;
            var settingsModule = new CompanySettings();
            settingsModule.editSetting(self.lookupLists.GlobalAcrobitsAccountSettingId);
        };
        CustomerPbxAccounts.prototype.editCustomerSettings = function () {
            var self = this;
            var settingsModule = new CompanySettings();
            settingsModule.deleteCustomerCallback = function () {
                self.customerAcrobitsSettingsId(0);
            };
            settingsModule.editCustomerSetting(self.customerAcrobitsSettingsId(), self.customerId(), self.lookupLists.GlobalAcrobitsAccountSettingId, function (data) {
                self.lookupLists.CustomerAcrobitsAccountSettingId = data.Id;
                self.customerAcrobitsSettingsId(data.Id);
            });
        };
        return CustomerPbxAccounts;
    }());
    return CustomerPbxAccounts;
});
//# sourceMappingURL=customerPbxAccounts.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/customers/customerPbxAccounts.js
// module id = 179
// module chunks = 2